import React from "react";
import { useCreateNewUserReflectionMutation } from "@/features/userReflections/userReflectionsApiSlice";
import { calculateWeekBoundaries } from "@/utils/dateUtils";

const EtDeleteUserReflectionComp = ({
  atomicRecord,
  onClose,
  refetchUserReflections,
  refetchUserReflectionsAll,
}) => {

  // First Created: 22 Sep 2024  
  // Author: Atul Pandey
  // Updated - 05 Dec 2025 - Built the complete logic to delete a user reflection note inside a UserReflection record and cascade to UserReflectionAll  

  // 1 - Extract essentials
  const weeklyNoteId = atomicRecord?.parentNoteId;
  const userId = atomicRecord?.userId;
  const userOrgId = atomicRecord?.userOrgId;

  // 2 - Magic moment safeguard
  const isMagicMoment = !!atomicRecord?.userMagicMomentId;

  // 3 - weekStarting Calculation 
  const today = new Date();
  const { weekStarting } = calculateWeekBoundaries(today);

  const [deleteReflection] = useCreateNewUserReflectionMutation();

  // 4 - Handle Delete
  const handleDelete = async () => {
    if (isMagicMoment) {
      alert("This note has been marked as a Magic Moment and cannot be deleted.");
      return;
    }

    try {
      const payload = {
        userId,
        userOrgId,
        weekStarting,
        userReflectionNotes: [
          {
            _id: weeklyNoteId,
            delete: true
          }
        ]
      };

      await deleteReflection(payload).unwrap();

      refetchUserReflectionsAll?.();
      refetchUserReflections?.();
      onClose();
    } catch (err) {
      console.error("Failed to delete reflection:", err);
      alert("Something went wrong while deleting the reflection.");
    }
  };

  // 5 - Create Markup
  const createMarkup = (html) => ({ __html: html });

  // 6 - No record found
  if (!atomicRecord) return <div>No reflection selected</div>;

  
  return (
    <div className="p-4 bg-white rounded">

      <h2 className="text-lg font-bold text-gray-800 mb-3">
        Delete Reflection
      </h2>
      

      <p className="text-sm text-gray-600 mb-4">
        Are you sure you want to delete this reflection?
      </p>
      <p className='mb-4 text-sm'><span className="text-red-600">Please remember, this action cannot be undone.</span> If you wish to proceed click <span className='font-bold text-red-600'>"Yes"</span> , else click <span className='font-bold'>"No"</span>  to go back.</p>

      <div dangerouslySetInnerHTML={createMarkup(atomicRecord?.reflectionNoteText?.slice(0, 180))} className="bg-gray-50 border p-3 rounded text-sm text-gray-700 mb-4">
      </div>

      {isMagicMoment && (
        <p className="text-red-600 text-sm mb-4">
          ⚠️ This reflection has been marked as a Magic Moment and cannot be deleted.
        </p>
      )}

      <div className="flex space-x-3 mt-4">
        <button
          className="w-24 bg-gradient-to-r from-red-900 to-orange-600 hover:bg-gradient-to-r hover:from-red-600 hover:to-red-700 text-white font-bold mx-2 py-2 px-4 rounded-full"
          disabled={isMagicMoment}
          onClick={handleDelete}
        >
          Yes
        </button>

        <button
          className="w-24 bg-gray-500 hover:bg-gray-700 text-white font-bold mx-2 py-2 px-4 rounded-full"
          onClick={onClose}
        >
          No
        </button>
      </div>
    </div>
  )
}

export default EtDeleteUserReflectionComp